var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "main", staticClass: "full-size" }, [
    _c(
      "table",
      {
        staticClass: "ct-table",
        attrs: { width: "100%", cellspacing: "0", cellpadding: "0" }
      },
      [
        _c("thead", { ref: "thead" }, [_vm._m(0)]),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.data, function(item, key) {
            return _vm.error == false
              ? _c(
                  "tr",
                  {
                    key: key,
                    on: {
                      click: function($event) {
                        return _vm.$router.push({
                          path: "/funddetail/" + item.fund_code
                        })
                      }
                    }
                  },
                  [
                    _c("td", [
                      _vm._v(
                        "\n                    " +
                          _vm._s(key + 1) +
                          "\n                "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n                    " +
                          _vm._s(item.fund_code) +
                          "\n                "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [_c("p", [_vm._v(_vm._s(item.fund_alias))])]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n\n                    " +
                          _vm._s(item.daten) +
                          "\n                "
                      )
                    ]),
                    _vm._v(" "),
                    item.navgrowthcalctype == "0"
                      ? _c("td", [
                          _c("span", { staticClass: "tip ared" }, [
                            _vm._v("*每万份收益")
                          ]),
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm._f("parseFloatFormat")(
                                  item.yield,
                                  "--",
                                  4,
                                  "1",
                                  ""
                                )
                              ) +
                              "\n                "
                          )
                        ])
                      : _c("td", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm._f("parseFloatFormat")(
                                  item.nav,
                                  "--",
                                  4,
                                  "1",
                                  ""
                                )
                              ) +
                              "\n                "
                          )
                        ]),
                    _vm._v(" "),
                    item.navgrowthcalctype == "0"
                      ? _c("td", [
                          _c("span", { staticClass: "tip ared" }, [
                            _vm._v("*7日年化收益率")
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              class: [
                                item.gain > 0
                                  ? "ared"
                                  : item.gain < 0
                                  ? "agreen"
                                  : ""
                              ]
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("parseFloatFormat")(
                                    item.gain,
                                    "--",
                                    2,
                                    "1",
                                    "%"
                                  )
                                )
                              )
                            ]
                          )
                        ])
                      : _c("td", [
                          _c(
                            "span",
                            {
                              class: [
                                item.gain > 0
                                  ? "ared"
                                  : item.gain < 0
                                  ? "agreen"
                                  : ""
                              ]
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("parseFloatFormat")(
                                    item.gain,
                                    "--",
                                    2,
                                    100,
                                    "%"
                                  )
                                )
                              )
                            ]
                          )
                        ])
                  ]
                )
              : _vm._e()
          }),
          0
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", [_vm._v("\n                    序号\n                ")]),
      _vm._v(" "),
      _c("th", [_vm._v("\n                    代码\n                ")]),
      _vm._v(" "),
      _c("th", [_vm._v("\n                    名称\n                ")]),
      _vm._v(" "),
      _c("th", [_vm._v("\n                    净值日期\n                ")]),
      _vm._v(" "),
      _c("th", [_vm._v("\n                    最新净值\n                ")]),
      _vm._v(" "),
      _c("th", [_vm._v("\n                    日涨跌幅\n                ")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fff0f0e8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fff0f0e8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tablelist.vue
// module id = null
// module chunks = 